import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import AFTableColumn from 'af-table-column';
import { hasAuth } from '@/assets/js/utils'
import Methods from '@/assets/js/methods';

//import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/public.scss'
import '@/assets/css/icon.scss'
import '@/assets/css/common.scss'

//权限处理方法注册
Vue.prototype.$hasAuth = hasAuth
//全局方法注册
Vue.use(Methods);
//element注册
Vue.use(ElementUI)
//af-table注册
Vue.use(AFTableColumn)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')